import React, { useState, useEffect } from "react";
import {
  Col,
  Container,
  Row,
  FormGroup,
  Button,
  Card,
  Label,
} from "reactstrap";
import avatar from "../../../assets/images/nav4.svg";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { useNavigate, useLocation } from "react-router-dom";
import { post, put, get } from "../../../api/axios";
import endpoints from "../../../api/endpoints";
import { toast, Bounce } from "react-toastify";
import imgupload from "../../../assets/images/imageupload.svg";
import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertToRaw, convertFromRaw } from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { values } from "lodash";
import { stateToHTML } from "draft-js-export-html";
import DetailView from "../../../components/DetailView";

const AddRequestFeature = () => {
  document.title = "Request Feature | Elevated - Admin Dashboard";
  const [equipmentFiles, setEquipmentFiles] = useState({ files: [] });
  const [isUpdate, setIsUpdate] = useState(false);
  const [blogId, setBlogId] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [initialValues, setInitialValues] = useState({
    userName: "",
    contactInfo: "",
    reason: "",
    description: "",
  });
  const [image, setImage] = useState("");

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const blogFromParams = searchParams.get("requestId");
    setBlogId(blogFromParams);

    if (blogFromParams) {
      setIsUpdate(true);
    }
  }, [location.search]);

  useEffect(() => {
    const fetchBlogDetails = async (id) => {
      try {
        const response = await get(`${endpoints.request}${id}`);
        if (response?.data) {
          setInitialValues(response.data.data);
          // const content = convertFromRaw(blogData?.content?.content);
          // setEditorState(EditorState.createWithContent(content));
        } else {
          toast.error("No data found for the contact us ID", {
            position: "bottom-center",
            theme: "colored",
            transition: Bounce,
          });
        }
      } catch (error) {
        console.error("Error fetching contact us details:", error);
        toast.error("Failed to fetch contact us details. Please try again.", {
          position: "bottom-center",
          theme: "colored",
          transition: Bounce,
        });
      }
    };

    if (isUpdate && blogId) {
      fetchBlogDetails(blogId);
    }
  }, [isUpdate, blogId]);
  const validationSchema = Yup.object().shape({});

  const handleSubmit = async (values) => {
    const formData = new FormData();
    formData.append("id", values.id);
    formData.append("reply", values.reply);
    formData.append("type", values.type);

    try {
      setIsSubmitting(true);
      if (isUpdate) {
        await put(`${endpoints.reply}`, formData);
        toast.success("Reply Submitted Successfully!", {
          position: "bottom-center",
          theme: "colored",
          transition: Bounce,
        });
      } else {
        await put(`${endpoints.reply}`, formData);
        toast.success("Reply Submitted Successfully!", {
          position: "bottom-center",
          theme: "colored",
          transition: Bounce,
        });
      }
      navigate("/list-requestfeature");
    } catch (error) {
      console.error(
        `Error ${isUpdate ? "updating" : "adding"} Contact Us`,
        error
      );
      toast.error("Something went wrong. Please try again.", {
        position: "bottom-center",
        theme: "colored",
        transition: Bounce,
      });
    } finally {
      setIsSubmitting(false);
    }
  };
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  function formatDate(dateString) {
    if (!dateString) return "";

    const date = new Date(dateString);

    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  }
  // Handle editor content change and pass to Formik
  const handleEditorChange = (state, setFieldValue) => {
    setEditorState(state);
    // Convert the editor state to raw content
    const content = convertToRaw(state.getCurrentContent());
    const htmlContent = stateToHTML(state.getCurrentContent());
    console.log(JSON.stringify({ content, htmlContent }));
    setFieldValue("reply", JSON.stringify({ content, htmlContent })); // Pass the raw content to Formik
  };
  return (
    <Container fluid>
      <Row>
        <Col>
          <Card className="rounded-4">
            <Formik
              initialValues={{
                id: initialValues.id,
                reply: "",
                type: "featureRequest", //featureRequest
              }}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
              enableReinitialize
            >
              {({ errors, touched, resetForm, setFieldValue }) => (
                <Form className="p-4">
                  <h3 className="primary-black ff-sora font-size-20 fw-bold">
                    Reply to Feature Request
                  </h3>

                  {/* General Info */}
                  <h5 className="secondary-black ff-sora  font-size-16 fw-600">
                    General Info
                  </h5>
                  <Row>
                    <div
                      style={{
                        borderRadius: "10px",
                        border: "1px solid #eaeced",
                        padding: "10px",
                      }}
                    >
                      <Col xs={12} sm={4} md={3} lg={3} className=" mb-md-0">
                        <p className="secondary-black ff-sora  font-size-16 fw-600">
                          Name :
                        </p>
                        <p className="secondary-black ff-sora  font-size-14 fw-600">
                          {initialValues.name}
                        </p>
                      </Col>

                      <Col
                        xs={12}
                        sm={12}
                        md={12}
                        lg={12}
                        className="  mb-md-0"
                      >
                        <p className="secondary-black ff-sora mt-4 font-size-16 fw-600">
                          Description :
                        </p>
                        <p className="secondary-black ff-sora font-size-14 fw-600">
                          {initialValues.description}
                        </p>
                      </Col>
                    </div>
                    <Col
                      xs={12}
                      sm={12}
                      md={12}
                      lg={12}
                      className="me-lg-1 mb-1 mb-md-0"
                    >
                      <p className="secondary-black ff-sora mt-4 font-size-16 fw-600">
                        Old Replies :
                      </p>
                      <ul
                        style={{
                          listStyle: "none",
                          borderRadius: "10px",
                          border: "1px solid #eaeced",
                          padding: "0px",
                        }}
                      >
                        {initialValues?.replies?.length <= 0 && (
                          <li className="d-flex align-items-center ">
                            <p className=" text-center ff-sora fw-normal font-size-16">
                              No reply Found!
                            </p>
                          </li>
                        )}
                        {initialValues?.replies?.map((item, index) => (
                          <li
                            key={index}
                            className="ff-sora p-2 m-1"
                            style={{
                              borderColor: "#eaeced",
                              borderWidth: 1,
                              borderStyle: "solid",
                              borderRadius: 12,
                            }}
                          >
                            <div className="d-flex align-items-center ">
                              <img
                                className="gymOwnerImageNew"
                                src={`${
                                  item?.user?.additionalInfo?.profileImage
                                    ? process.env.REACT_APP_IMG_URL +
                                      item?.user?.additionalInfo?.profileImage
                                    : avatar
                                }`}
                                alt=""
                              />
                              <p className="m-0 font-size-16 tertiary-black ff-sora">
                                {item?.user?.firstName} {item?.user?.lastName}
                              </p>
                              <p className="mx-2 my-0 font-size-12 tertiary-black ff-sora">
                                {formatDate(item?.createdAt)}
                              </p>
                            </div>
                            <p className="my-2 font-size-14 fw-bold tertiary-black ff-sora">
                              Reply :
                            </p>
                            <DetailView
                              className="ff-sora"
                              rawContent={item?.comment?.content}
                            />
                          </li>
                        ))}
                      </ul>
                    </Col>
                    <h5 className="secondary-black ff-sora mt-4 font-size-16 fw-normal">
                      Reply
                    </h5>
                    <Col
                      xs={12}
                      sm={12}
                      md={12}
                      lg={12}
                      className="me-lg-1 mb-1 mb-md-0"
                    >
                      <FormGroup>
                        <Editor
                          editorState={editorState}
                          toolbarClassName="toolbarClassName"
                          wrapperClassName="wrapperClassName"
                          editorClassName="editorClassName"
                          onEditorStateChange={(state) =>
                            handleEditorChange(state, setFieldValue)
                          }
                        />
                        {/* <Field
                          name="content"
                          type="text"
                          placeholder="Blog Description"
                          style={{
                            width: "100%",
                            maxWidth: "412px",
                            height: "56px",
                            border: "none",
                          }}
                          className={`rounded-5 bg-light ff-sora font-size-16 fw-normal px-4 ${
                            errors.content && touched.content
                              ? " is-invalid"
                              : ""
                          }`}
                        /> */}
                        {errors.content && touched.content && (
                          <div className="text-danger font-size-12 ff-sora fw-normal my-1">
                            {errors.content}
                          </div>
                        )}
                      </FormGroup>
                    </Col>
                  </Row>

                  {/* Submit Button */}
                  <div className="d-flex justify-content-end mt-4">
                    <Button
                      type="submit"
                      className="me-2 rounded-pill"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? (
                        isUpdate ? (
                          <span>Updating...</span>
                        ) : (
                          <span>Adding...</span>
                        )
                      ) : isUpdate ? (
                        "Reply"
                      ) : (
                        "Add contact us"
                      )}
                    </Button>
                    <Button
                      color="white"
                      className="rounded-pill1"
                      onClick={() => {
                        resetForm();
                        if (isUpdate) {
                          navigate("/list-requestfeature");
                        }
                      }}
                    >
                      Cancel
                    </Button>
                  </div>
                </Form>
              )}
            </Formik>
          </Card>
          <div
            className="d-flex justify-content-between align-items-center"
            style={{
              height: "60px",
              position: "sticky",
              bottom: "0",
              zIndex: "10",
            }}
          ></div>
        </Col>
      </Row>
    </Container>
  );
};

export default AddRequestFeature;
